export default {"src":"/_next/static/media/picto-men.3647f6e3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};